var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneLifeWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1900.14 441.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        letter-spacing: .28em;\r\n      }\r\n\r\n      .cls-2 {\r\n        font-family: Garamond, Garamond;\r\n        font-size: 115.69px;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill: #0d3f5b;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: none;\r\n        stroke: #0b3f5b;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-3 {\r\n        font-family: Garamond-Bold, Garamond;\r\n        font-size: 347.06px;\r\n        font-weight: 700;\r\n        letter-spacing: -.01em;\r\n      }\r\n\r\n      .cls-5 {\r\n        letter-spacing: .3em;\r\n      }\r\n\r\n      .cls-6 {\r\n        letter-spacing: .3em;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(99.18 284.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ONE LIFE")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(378.56 405.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 110.62,
    y: 0
  }, "Q"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 232.32,
    y: 0
  }, "UITY FUND")), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 342.94,
    y1: 368.98,
    y2: 368.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1900.14,
    y1: 369.98,
    x2: 1557.2,
    y2: 369.98
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLifeWordmark);
export default __webpack_public_path__ + "static/media/OneLife_Wordmark.4b6170977605515a6a38b16d57a6e093.svg";
export { ForwardRef as ReactComponent };